import { render, staticRenderFns } from "./AboutContact.vue?vue&type=template&id=69e35f4b&"
import script from "./AboutContact.vue?vue&type=script&lang=js&"
export * from "./AboutContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports